import React from 'react';
import { ArrowRight, Play } from 'lucide-react';
import { Button } from './ui/button';

const Hero = () => {
  return (
    <section id="home" className="relative min-h-screen flex items-center pt-20" style={{ backgroundColor: '#ECEC75' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-8">
            <div className="inline-block">
              <span className="px-4 py-2 bg-white rounded-full text-sm font-semibold text-gray-900">
                #1 Digital Marketing Agency in Zirakpur
              </span>
            </div>
            
            <h1 className="text-5xl lg:text-6xl font-bold text-gray-900 leading-tight" style={{ fontFamily: 'var(--font-serif)' }}>
              Elevate Your Business with Strategic Digital Marketing
            </h1>
            
            <p className="text-lg text-gray-700 leading-relaxed">
              From video production to social media campaigns, we help professionals and businesses grow their digital presence through Meta, Google AdWords, and innovative marketing strategies.
            </p>

            <div className="flex flex-wrap gap-4">
              <Button 
                className="bg-black text-white hover:bg-gray-800 px-8 py-6 text-lg font-semibold flex items-center gap-2"
              >
                Start Your Campaign
                <ArrowRight className="w-5 h-5" />
              </Button>
              
              <Button 
                variant="outline" 
                className="border-2 border-black text-black hover:bg-black hover:text-white px-8 py-6 text-lg font-semibold flex items-center gap-2"
              >
                <Play className="w-5 h-5" />
                Watch Our Work
              </Button>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-8 pt-8 border-t border-gray-300">
              <div>
                <div className="text-3xl font-bold text-gray-900" style={{ fontFamily: 'var(--font-serif)' }}>500+</div>
                <div className="text-sm text-gray-600 mt-1">Happy Clients</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-gray-900" style={{ fontFamily: 'var(--font-serif)' }}>1000+</div>
                <div className="text-sm text-gray-600 mt-1">Campaigns Delivered</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-gray-900" style={{ fontFamily: 'var(--font-serif)' }}>98%</div>
                <div className="text-sm text-gray-600 mt-1">Client Satisfaction</div>
              </div>
            </div>
          </div>

          {/* Right Content - Hero Image */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://images.unsplash.com/photo-1557838923-2985c318be48?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwxfHxkaWdpdGFsJTIwbWFya2V0aW5nfGVufDB8fHx8MTc3NTQwODEzM3ww&ixlib=rb-4.1.0&q=85"
                alt="Digital Marketing"
                className="w-full h-auto object-cover"
              />
            </div>
            
            {/* Floating Card */}
            <div className="absolute -bottom-6 -left-6 bg-white rounded-xl shadow-lg p-6 max-w-xs">
              <div className="flex items-center space-x-4">
                <div className="w-12 h-12 bg-green-500 rounded-full flex items-center justify-center">
                  <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
                  </svg>
                </div>
                <div>
                  <div className="text-2xl font-bold text-gray-900">300%</div>
                  <div className="text-sm text-gray-600">Average ROI Growth</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
